// hooks/useStorageReadOnly.ts
import { useStorageState } from '../contexts/StorageStateContext';

/**
 * Hook to check if storage is in read-only mode
 * Use this to disable create buttons and show appropriate UI
 */
export function useStorageReadOnly() {
  const { storageState } = useStorageState();
  
  return {
    isReadOnly: storageState?.readOnly || false,
    isAlmostFull: storageState?.almostFull || false,
    percentage: storageState?.percentage || 0,
    storageState,
  };
}

